'use client';

import { useTranslations } from 'next-intl';
import { TOAST_IDS } from '@/config/toast-ids';
import { onEvent } from '@/events';
import { showToast } from '@/lib/ui/toast';

interface WalletSwitchNotice {
  fromWalletId: string | null;
  toWalletId: string;
  label: string;
}

/**
 * Returns a function that fires a confirmation toast when the active wallet
 * changes. Used by every UI that switches the active wallet (header dropdown,
 * mobile sheet, manage-wallets modal, settings page) so the message + toast id
 * stay consistent.
 */
export function useNotifyWalletSwitched(): (notice: WalletSwitchNotice) => void {
  const t = useTranslations('wallet');
  return ({ fromWalletId, toWalletId, label }: WalletSwitchNotice): void => {
    onEvent('wallet_switched', {
      from_wallet_id: fromWalletId,
      to_wallet_id: toWalletId,
    });
    showToast({
      id: TOAST_IDS.WALLET_SWITCHED,
      message: t('switched_for_trading', { label }),
      variant: 'success',
    });
  };
}
